export const ApiUrl = 'http://128.199.26.115';
// export const ApiUrl = 'https://api.ayekart.com/biz';

export const ApiUrl1 = 'http://206.189.139.114';
// export const ApiUrl1 = 'http://139.59.91.183';

export const ApiUrl2 = 'https://stagingworkflow.ayekart.com';
// export const ApiUrl2 = 'https://139.59.79.10';


export const local_access = '';

// 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


// powesheell >
// ssh root@139.59.94.40
// password : dc9INzG08^9X
//  cd miniErp > git pull origin master 
// npm run build
// pm2 stop all
// then pm2 start all

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  borderTop: "7px solid #99243D",
  p: 2,
};
